/* Daddy's Girl Collection — accessible global motion enhancements.
   Never hides content before an animation. No third-party dependencies. */
(function(){
  'use strict';
  if(window.__dgcGlobalMotionBooted)return;
  window.__dgcGlobalMotionBooted=true;
  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dataSaver=!!(navigator.connection&&navigator.connection.saveData);
  var animateAllowed=!reduced&&!dataSaver;
  var selector=[
    'main product-card.product-card',
    'main .product-card:not(.dgc-product-card)',
    'main .product-information__media',
    'main .product-details',
    'main .dgc-connection__path',
    'main .dgc-film__product',
    'main .dgc-shopping-information .dgc-shop-help__links > a',
    'main .dgc-pagination',
    'main .dgc-reviews-app--product',
    'main .dgc-collection-page__head',
    'main .dgc-collection-toolbar',
    'main .dgc-collection-page__description',
    '.dgc-site-foot__grid > div'
  ].join(',');
  var io=null;
  function trigger(el,index){
    if(!el||el.dataset.dgcMotionDone==='true')return;
    el.dataset.dgcMotionDone='true';
    if(!el.animate)return;
    var isCard=el.matches('product-card,.product-card,.dgc-film__product,.dgc-connection__path');
    var duration=isCard?510:720;
    var distance=isCard?16:24;
    var delay=Math.min(index%5,4)*62;
    try{
      el.animate([
        {opacity:.12,transform:'translate3d(0,'+distance+'px,0)'},
        {opacity:1,transform:'translate3d(0,0,0)'}
      ],{duration:duration,delay:delay,easing:'cubic-bezier(.22,1,.36,1)',fill:'none'});
    }catch(err){/* CSS and visible content remain functional. */}
  }
  function setupObserver(){
    if(!animateAllowed||!('IntersectionObserver'in window))return;
    io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        io.unobserve(entry.target);
        trigger(entry.target,Number(entry.target.dataset.dgcMotionIndex||0));
      });
    },{root:null,threshold:.06,rootMargin:'0px 0px -35px 0px'});
  }
  function install(root){
    if(!animateAllowed||!io)return;
    var nodes=(root||document).querySelectorAll(selector);
    var count=0;
    nodes.forEach(function(el){
      if(el.dataset.dgcMotionTracked==='true'||el.closest('.jdgm-widget,.jdgm-carousel-wrapper,.dgc-gift-story'))return;
      if(el.matches('[aria-hidden="true"]'))return;
      el.dataset.dgcMotionTracked='true';
      el.dataset.dgcMotionIndex=String(count%5);
      count++;
      io.observe(el);
    });
  }
  function installProgress(){
    if(!document.body||document.querySelector('.dgc-motion-progress'))return;
    var progress=document.createElement('div');
    progress.className='dgc-motion-progress';
    progress.setAttribute('aria-hidden','true');
    document.body.appendChild(progress);
    var back=document.createElement('button');
    back.type='button';
    back.className='dgc-scroll-top';
    back.setAttribute('aria-label','Back to top');
    back.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 14 7-7 7 7M12 7v13"/></svg>';
    document.body.appendChild(back);
    var page=document.querySelector('.page-wrapper');
    var scrolling=null;
    function scrollNode(){
      if(page&&page.scrollHeight>page.clientHeight+40){
        var st=window.getComputedStyle(page);
        if(st.overflowY==='auto'||st.overflowY==='scroll')return page;
      }
      return document.scrollingElement||document.documentElement;
    }
    var queued=false;
    function update(){
      queued=false;
      scrolling=scrollNode();
      var max=Math.max(0,scrolling.scrollHeight-scrolling.clientHeight);
      var top=Math.max(0,scrolling.scrollTop);
      progress.style.transform='scaleX('+(max?Math.min(1,top/max):0)+')';
      back.classList.toggle('is-visible',top>600);
    }
    function schedule(){
      if(queued)return;
      queued=true;
      window.requestAnimationFrame(update);
    }
    back.addEventListener('click',function(){
      var el=scrollNode();
      el.scrollTo({top:0,behavior:reduced?'instant':'smooth'});
    });
    window.addEventListener('scroll',schedule,{passive:true});
    if(page)page.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    update();
  }
  function boot(){
    setupObserver();
    install(document);
    installProgress();
    document.addEventListener('shopify:section:load',function(e){install(e.target);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
